import type React from "react";
import { i18n } from "@frontend/i18n";
import { LocalizedTextUtils } from "@shared/utils/localized-text.utils";
import type { LocalizedText } from "@shared/schemas/localized-text.schemas";
import { WavesMark } from "../EmptyStateMarks";

export interface LinkedInSectionProps {
  readonly summary: LocalizedText | null;
  readonly isOwnProfile?: boolean;
}

export function LinkedInSection({
  summary,
  isOwnProfile = false,
}: LinkedInSectionProps): React.JSX.Element {
  if (summary === null) {
    return (
      <div
        className="flex flex-col items-center justify-center px-4 py-12"
        data-testid="linkedin-not-available"
      >
        <WavesMark className="mb-2.5 h-6 w-6 text-border" />
        <h2 className="mb-2.5 font-serif text-base font-normal text-foreground">
          {i18n.t("participantProfile.linkedin.notAvailable")}
        </h2>
        <p className="text-center text-pds-2xs leading-relaxed text-muted-foreground">
          {i18n.t(
            isOwnProfile
              ? "participantProfile.linkedin.notAvailableDescriptionOwn"
              : "participantProfile.linkedin.notAvailableDescription",
          )}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1" data-testid="linkedin-section">
      <h2 className="text-sm font-semibold text-foreground">
        {i18n.t("participantProfile.linkedin.title")}
      </h2>
      <p className="text-pds-xs text-foreground leading-normal whitespace-pre-wrap">
        {LocalizedTextUtils.resolve(summary, i18n.getLocale())}
      </p>
    </div>
  );
}
